import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      _createElementVNode("path", { d: "M20.81 8.35v3.967c0 3.969-1.588 5.556-5.556 5.556h-2.381c-3.968 0-5.556-1.587-5.556-5.556V7.556C7.317 3.587 8.905 2 12.873 2h1.587" }),
      _createElementVNode("path", { d: "M16.61 17.796c-.352 2.98-2 4.203-5.483 4.203H8.746c-3.968 0-5.556-1.587-5.556-5.555v-4.762c0-3.41 1.173-5.062 4.02-5.46m13.6 2.128h-3.175c-2.381 0-3.175-.794-3.175-3.175V2l6.35 6.35Zm-9.524 2.38h4.762m-4.762 3.174h3.175" })
    ], -1)
  ]))]))
}
export default { render: render }